import React, { useState, useEffect, useRef } from 'react';
import { Icons as I } from '../pack-icons';
import i18n from '../../i18n';

const STORAGE_KEY = 'dathent-lang';

const LANGS = [
  { code: 'en', name: 'English' },
  { code: 'uk', name: 'Українська' },
  { code: 'ru', name: 'Русский' },
  { code: 'es', name: 'Español', soon: true },
  { code: 'de', name: 'Deutsch', soon: true },
  { code: 'fr', name: 'Français', soon: true },
  { code: 'pt', name: 'Português', soon: true },
];

/**
 * LangSwitch — dropdown for language selection.
 * Wires to i18next via dynamic import to avoid hard dep before i18n setup lands.
 */
export default function LangSwitch() {
  const [open, setOpen] = useState(false);
  const [lang, setLang] = useState(() => {
    if (typeof window === 'undefined') return 'en';
    return localStorage.getItem(STORAGE_KEY) || 'en';
  });
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (!ref.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const handlePick = (code) => {
    setLang(code);
    localStorage.setItem(STORAGE_KEY, code);
    setOpen(false);
    i18n?.changeLanguage?.(code);
  };

  const active = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <div className={`lang-dd ${open ? 'is-open' : ''}`} ref={ref}>
      <button className="lang-trigger" onClick={() => setOpen((o) => !o)} type="button">
        <span className="code">{active.code.toUpperCase()}</span>
        <span>{active.name}</span>
        <I.chevDown className="caret" size={11} />
      </button>
      <div className="lang-panel" role="menu">
        {LANGS.map((l) => (
          <button
            key={l.code}
            className={`lang-option ${lang === l.code ? 'is-active' : ''} ${l.soon ? 'is-soon' : ''}`}
            onClick={() => !l.soon && handlePick(l.code)}
            type="button"
          >
            <span className="lc">{l.code.toUpperCase()}</span>
            <span className="ln">{l.name}</span>
            {lang === l.code && <I.check className="lk" size={14} />}
          </button>
        ))}
      </div>
    </div>
  );
}
